import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, FileDownIcon, HelpCircleIcon } from "lucide-react";
import { useSeo } from "../../hooks/useSeo";
import { PageHero } from "../../components/ui/PageHero";
import { CtaBand } from "../../components/ui/CtaBand";
import { Reveal } from "../../components/ui/Reveal";
import { PlaceholderTag } from "../../components/ui/PlaceholderTag";
import { ARTICLES } from "../../data/resources";
export function Resources() {
  useSeo({
    title: "Resources",
    description: "Guides, FAQs and a free website checklist from NEXORA Web Studio.",
    path: "/resources"
  });
  return <>
      <PageHero crumbs={[{
      label: "Resources"
    }]} eyebrow="Resources" title="Guides for owners building online." lead="Practical advice on websites, local search and keeping your site healthy." data-id="element-834" data-mp="19r9fp64zv0i8" />

      <section className="shell grid gap-[clamp(1rem,1.6vw,2rem)] pt-[clamp(3rem,5vw,6rem)] md:grid-cols-2" data-id="element-835" data-mp="m3i1ty3t2feu">
        <Reveal data-id="element-836" data-mp="s7rtcz69dcms">
          <Link to="/resources/website-checklist" className="group flex h-full items-start gap-5 rounded-[clamp(1rem,1.2vw,1.5rem)] border border-accent/50 bg-ink-2 p-[clamp(1.5rem,2.4vw,2.75rem)] transition-[transform,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-accent" data-id="element-837" data-mp="s66yt9jy1tox">
            <FileDownIcon className="h-7 w-7 shrink-0 text-accent-soft" aria-hidden data-id="element-838" data-mp="dhan92iohyjk" />
            <span className="flex-1" data-id="element-839" data-mp="9h0kdyq6no8x">
              <span className="t-h3 block" data-id="element-840" data-mp="9i1zceabkuvx">Free website checklist</span>
              <span className="mt-2 block text-muted" data-id="element-841" data-mp="4gmeonc20qe2">Everything to gather before you build. Free download.</span>
            </span>
            <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-muted group-hover:text-fg" aria-hidden data-id="element-842" data-mp="3vq1hla724asw" />
          </Link>
        </Reveal>
        <Reveal delay={0.05} data-id="element-843" data-mp="1twc2iu5kowuc">
          <Link to="/resources/faq" className="group flex h-full items-start gap-5 rounded-[clamp(1rem,1.2vw,1.5rem)] border border-line bg-ink-2 p-[clamp(1.5rem,2.4vw,2.75rem)] transition-[transform,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-line-strong" data-id="element-844" data-mp="1tvankelfrq7c">
            <HelpCircleIcon className="h-7 w-7 shrink-0 text-accent-soft" aria-hidden data-id="element-845" data-mp="3o4pi6wxeeiz4" />
            <span className="flex-1" data-id="element-846" data-mp="39g1rp52eszg1">
              <span className="t-h3 block" data-id="element-847" data-mp="39h4kjijalbyl">Frequently asked questions</span>
              <span className="mt-2 block text-muted" data-id="element-848" data-mp="3efo6vk1ssprh">Search every question about pricing, process and hosting.</span>
            </span>
            <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-muted group-hover:text-fg" aria-hidden data-id="element-849" data-mp="5zme9fj64d0a" />
          </Link>
        </Reveal>
      </section>

      <section className="shell section" data-id="element-850" data-mp="3t4aknhbs19gl">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-4" data-id="element-851" data-mp="3t39adf2l4qzx">
          <h2 className="t-h2" data-id="element-852" data-mp="yf1f2264nmr">Blog</h2>
          <PlaceholderTag data-id="element-853" data-mp="11kq4g6vxnhy">Articles in progress</PlaceholderTag>
        </div>
        <ul className="border-t border-line-strong" data-id="element-854" data-mp="2hn2gmx51lvcy">
          {ARTICLES.map((a, i) => <Reveal as="li" key={a.title} delay={Math.min(i, 5) * 0.03} className="grid gap-2 border-b border-line py-[clamp(1.25rem,2vw,2.25rem)] md:grid-cols-[minmax(160px,0.5fr)_2fr_auto] md:items-baseline md:gap-8" data-id="element-855" data-mp="2lrihgjzsuclb" data-mpi={i}>
              <p className="t-eyebrow text-accent-soft" data-id="element-856" data-mp="299pnatofr85h">{a.category}</p>
              <div data-id="element-857" data-mp="2o43y46xujb92">
                <h3 className="font-display text-[clamp(1.15rem,1rem+0.6vw,1.9rem)] font-medium tracking-tight" data-id="element-858" data-mp="2o2jdb91c36oe">{a.title}</h3>
                <p className="mt-1 text-muted" data-id="element-859" data-mp="1vfowcm3q6pfo">{a.excerpt}</p>
              </div>
              <span className="font-mono text-sm text-muted" data-id="element-860" data-mp="1vdlvf711bbw6">Coming soon</span>
            </Reveal>)}
        </ul>
      </section>

      <CtaBand source="resources" data-id="element-861" data-mp="255zzi6fl4uli" />
    </>;
}